import { InMemoryCache } from '@apollo/client';
import { GraphQLGatewayPossibleTypes } from '@atlassian/mpac-types/graphql-gateway-types';
import { categoryMergePolicy } from '../dla-handlers/Category/CategoryMergePolicy';
import { appSearchMergePolicy } from '../dla-handlers/SearchResult/AppSearchMergePolicy';
export const createApolloCache = initialState => {
  const cache = new InMemoryCache({
    possibleTypes: GraphQLGatewayPossibleTypes,
    typePolicies: {
      // Workaround for this apollo bug: https://github.com/apollographql/apollo-client/issues/7636
      // by disabling caching for this field (https://bit.ly/371l02H)
      CompatibleAtlassianProduct: {
        keyFields: false
      },
      Query: {
        fields: {
          marketplaceSearch: {
            keyArgs: ['query', 'filters', 'sort'],
            merge: appSearchMergePolicy
          },
          marketplaceCategory: {
            keyArgs: ['slug'],
            merge: categoryMergePolicy
          }
        }
      }
    }
  });
  if (typeof initialState !== 'undefined') {
    cache.restore(initialState);
  }
  return cache;
};